export const getResultColorClass = (value: number): string => {
    if (value === 0) return "bg-[#FED7D7] text-[#822727]"
    if (value === 2.5) return "bg-[#FEEBC8] text-[#7B341E]"
    if (value === 5) return "bg-[#C6F6D5] text-[#22543D]"
    return null
}